const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the workflow list
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('groupUsersList', ['Application', 'Users', 'Groups', '$location', '$translate', function (Application, Users, Groups, $location, $translate) {
  return {
    restrict: 'E',
    scope: {},
    template: require('../../../templates/directives/groups/group-users-list.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.routeParams = Application.navigation.getRouteParameters();
      self.addMode = false;
      self.type = self.routeParams.type || 'users';
      self.groupId = self.routeParams.id;
      self.group = {};

      self.back = function() {
        Application.navigation.goTo('/overview/settings/groups', {});
      };

      if (!self.groupId) {
        self.back();
        return;
      }

      self.tabChange = function(type) {
        if (type === 'users') {
          self.activeType = self.users;
        }
        if (type === 'managers') {
          self.activeType = self.managers;
        }
        if (!self.displayed[type]) {
          self.displayed[type] = true;
          self.activeType.get();
        }
        // Clear addition settings
        self.mode = '';
        self.type = type;

        self.selectionBlock = {};
        self.selection = [];
        $location.path('/view/groups/' + self.groupId).search('type', self.type);
      };

      self.getDepartment = function(user) {
        if (user.linked_departments && user.linked_departments[0] && user.linked_departments[0].name) {
          return user.linked_departments[0].name;
        }

        return '-----';
      };

      self.getLocation = function(user) {
        if (user.linked_locations && user.linked_locations[0] && user.linked_locations[0].name) {
          return user.linked_locations[0].name;
        }

        return '-----';
      };

      self.displayed = {
        users: false,
        managers: false,
        add: false
      };

      self.selectionBlock = {};
      self.selection = [];

      self.select = function (id, user) {
        self.selectionBlock[id] = user;
        var index = self.selection.indexOf(id);
        if (index === -1) {
          self.selection.push(id);
          return;
        }
        self.selection.splice(index, 1);
      };

      self.search = {
        term: '',
      };

      self.remove = function() {
        if (self.type === 'users') {
          self.users.remove();
          return;
        }
        self.managers.remove();
      };

      self.users = {
        list: [],
        page: 1,
        per_page: 15,
        last_page: null,
        get: function() {
          Users.find({
            fields: '_id,first_name,last_name,full_name,email,image,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade,groups',
            'linked_locations-populate': 'name',
            'linked_departments-populate': 'name',
            page: self.users.page,
            per_page: self.users.per_page,
            groups: self.groupId
          }).$promise.then(function(results) {
            if (!results.length) {
              self.users.last_page = self.users.page - 1 || 1;
              self.users.page = self.users.last_page;
              return;
            }

            if (results.length < self.users.per_page) {
              self.users.last_page = self.users.page;
            }

            self.users.list = results;

          }).catch(function(error) {
            console.log('Error in getting admin users: ', error);
          });
        },
        next: function() {
          if (self.users.last_page !== null && self.users.page >= self.users.last_page) {
            return;
          }

          self.users.page++;
          self.users.get();
        },
        previous: function() {
          if (self.users.page < 2) {
            return;
          }
          self.users.page--;
          self.users.get();
        },
        remove: function() {
          self.users.removing = true;
          Groups.removeFromUsers({subresource: self.groupId, remove_managers: false}, {users: self.selection}).$promise
          .then(function(results) {
            Application.messaging.addMessage({type: 'success', duration: 5, text: 'Users removed.'});
            self.users.get();
            self.users.removing = false;
            self.selection = [];
            self.selectionBlock = {};
          }).catch(function(error) {
            self.users.removing = false;
            console.log('error in removing: ', error);
          });
        },
        onAdded: function() {
          self.users.get();
        }
      };

      self.managers = {
        list: [],
        page: 1,
        per_page: 15,
        last_page: null,
        removing: false,
        get: function() {
          Users.find({
            fields: '_id,first_name,last_name,full_name,email,image,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade,managing_groups',
            'linked_locations-populate': 'name',
            'linked_departments-populate': 'name',
            managing_groups: self.groupId,
            page: self.managers.page,
            per_page: self.managers.per_page
          }).$promise.then(function(results) {
            if (!results.length) {
              self.managers.last_page = self.managers.page - 1 || 1;
              self.managers.page = self.managers.last_page;
              return;
            }

            if (results.length < self.managers.per_page) {
              self.managers.last_page = self.managers.page;
            }

            self.managers.list = results;

          }).catch(function(error) {
            console.log('Error in getting admin users: ', error);
          });
        },
        next: function() {
          if (self.managers.last_page !== null && self.managers.page >= self.managers.last_page) {
            return;
          }

          self.managers.page++;
          self.managers.get();
        },
        previous: function() {
          if (self.managers.page < 2) {
            return;
          }
          self.managers.page--;
          self.managers.get();
        },
        remove: function() {
          self.managers.removing = true;
          Groups.removeFromUsers({subresource: self.groupId, remove_managers: true}, {users: self.selection}).$promise
          .then(function(results) {
            Application.messaging.addMessage({type: 'success', duration: 5, text: 'Managers removed.'});
            self.managers.get();
            self.managers.removing = false;
            self.selection = [];
            self.selectionBlock = {};
          }).catch(function(error) {
            self.managers.removing = false;
            console.log('error in removing: ', error);
          });
        },
        onAdded: function() {
          self.managers.get();
        }
      };

      self.cancelAdd = function() {
        self.addMode = false;
      };

      self.activeType = self.users;

      self.initialize = function() {
        if (self.type === 'users') {
          self.activeType = self.users;
        }
        if (self.type === 'managers') {
          self.activeType = self.managers;
        }

        self.activeType.get();
        Groups.get({subresource: self.groupId, fields: '_id,name'}).$promise
        .then(function(results) {
          self.group = results;
        }).catch(function(error) {
          console.log('error: ', error);
        });

      };

      self.initialize();

      $translate([
        'global.label.users',
        'global.label.locations',
        'global.label.departments'
      ]).then(function (translations) {
        self.translations = translations;
      });

    }],
    controllerAs: 'groupList'
  }
}]);